import loader from "../../assets/images/loader.gif";
import "./LoaderPetroprix.css";

export const LoaderPetroprix = ({
  type = "",
  position = "fixed",
  min = "16vh",
}) => {
  return (
    <div className={`loaderPetroprix ${type}`} style={{ minHeight: min }}>
      <img src={loader} alt="loading" width="100" height="100" />
    </div>
  );
};
